<template>
    <div id="table-box">
        <van-row justify="center">
            <van-col span="6">
                <van-image
                    width="5rem"
                    height="5rem"
                    src="https://afa.activa-leisure.com/img/activa.jpg"
                />
            </van-col>
        </van-row>
        <van-row justify="center">
            <van-col span="20">
                <div class="van-multi-ellipsis--l4">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;欢迎进入宁波万汇投诉建议平台, 您所提报的信息，公司会逐一落实，您的个人信息会予以保密。</p>
<!--                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请您在反馈时，将时间、地点、人物、事件描述清楚，以便我们落实纠正。
                    我们会及时反馈您所提报的问题，对于您的个人信息公司将予以保密。</p>-->
                </div>
            </van-col>
        </van-row>
    </div>
    <van-form @submit="onSubmit">
        <van-cell-group inset style="margin-top: 20px">
            <van-field
                v-model="title"
                name="title"
                required
                label="提报标题"
                placeholder="请输入标题"
                :rules="[{validator: titleMessage}]"
            />
        </van-cell-group>

        <van-radio-group v-model="checked" style="margin-top: 20px">
            <van-cell-group inset>
                <van-cell title="匿名提报" clickable @click="clickChecked('1')">
                    <template #right-icon>
                        <van-radio name="1"/>
                    </template>
                </van-cell>
                <van-cell title="署名提报" clickable @click="clickChecked('2')">
                    <template #right-icon>
                        <van-radio name="2"/>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-radio-group>
        <van-cell-group inset style="margin-top: 20px" v-if="useRefs">
            <van-field
                    v-model="name"
                    name="name"
                    required
                    label="姓名"
                    placeholder="请输入姓名"
                    :rules="[{validator: nameMessage}]"
            />
            <van-field
                    v-model="phone"
                    name="phone"
                    required
                    type="digit"
                    label="手机号"
                    placeholder="请输入手机号"
                    :rules="[{validator: phoneMessage}]"
            />
        </van-cell-group>
        <van-cell-group inset style="margin-top: 20px">
            <van-field
                    v-model="results"
                    is-link
                    required
                    readonly
                    name="happen_date"
                    label="时间选择"
                    placeholder="点击选择时间"
                    :rules="[{ required: true, message: '请选择发生时间' }]"
                    @click="placeholderPicker"
            />
        </van-cell-group>
        <van-popup v-model:show="showPicker" position="bottom">
            <van-date-picker v-model="currentDate" @confirm="onConfirm" @cancel="showPicker = false"/>
        </van-popup>
        <van-cell-group inset style="margin-top: 20px">
            <van-field
                    v-model="description"
                    name="description"
                    rows="2"
                    autosize
                    required
                    label="事件描述"
                    type="textarea"
                    maxlength="300"
                    placeholder="请在此处填写详细内容，注意将人物、地点、时间、原因、结果等详细信息填写完整。"
                    :rules="[{ required: true, message: '请填写事件描述' }]"
                    show-word-limit
            />
        </van-cell-group>
        <van-row justify="center">
            <van-col span="22">
                <div style="margin-top: 16px;margin-bottom: 130px">
                    <van-button round block type="primary" native-type="submit">
                        提交
                    </van-button>
                </div>
            </van-col>
        </van-row>
    </van-form>
    <van-floating-bubble
        axis="xy"
        icon="chat"
        magnetic="x"
        style="--van-floating-bubble-background: #16b777"
        @click="bubbleBottom"
    />
    <van-popup
        v-model:show="popupShow"
        round
        position="bottom"
        :style="{ height: '70%' }"
    >
        <van-nav-bar title="提报历史" style="position:fixed;width: 100%;" />
        <van-cell-group inset style="margin-top: 40px" v-if="Object.keys(view_complaint).length!=0">
            <div v-for="complaint in view_complaint" :key="complaint.id">
                <van-cell title="提报状态" value="已回复" v-if="complaint.state == 'Y'" :label="'提报单号：'+complaint.id" is-link style="--van-cell-value-color: blue" @click="cellSubmit(complaint.id)"/>
                <van-cell title="提报状态" value="未回复" v-else :label="'提报单号：'+complaint.id" is-link style="--van-cell-value-color: red" @click="cellSubmit(complaint.id)"/>
            </div>
        </van-cell-group>
        <van-notice-bar color="#1989fa" background="#ecf9ff" v-else left-icon="info-o" style="margin-top: 50px">
            你还未提报过。
        </van-notice-bar>
    </van-popup>
</template>

<script setup>
import {getCurrentInstance, onMounted, ref} from 'vue';
import { useRouter } from "vue-router";
// import "@/js/jweixin-1.6.0"
import axios from 'axios'
import {showLoadingToast, closeToast, showDialog, showSuccessToast, showFailToast} from "vant";
const checked = ref('1');
const name = ref();
const description = ref();
const phone = ref();
const title = ref();
const results = ref('');
const showPicker = ref(false);
const useRefs = ref(false);
const currentDate = ref();
const openid = ref();
const popupShow = ref(false);
const view_complaint = ref([]);
// onMounted(async() => {
//    const data = await axios.get('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx34bc811494212e27&redirect_uri=https://afa.activa-leisure.com/lj/back/cs&response_type=code&scope=snsapi_base&state=123&connect_redirect=1#wechat_redirect')
//     console.log(data)
// })
const {proxy} = getCurrentInstance()

onMounted(() => {
    window.document.title = '宁波万汇投诉建议平台'
    showLoadingToast({
        overlay:true,
        forbidClick:true,
        message: '加载中...',
        duration:0
        // forbidClick: true,
    });
    console.log(location.href.split('code='))
    const cookies = proxy.$cookies.get('OpenId')
    console.log(cookies)
    if (cookies != "" && cookies != null){
        closeToast();
        openid.value = cookies;
    }else {
        axios.post("https://afa.activa-leisure.com/lj/back/wx_openid",
            //{code:location.href.split('code=')[1].split('&')[0]},
            {code:location.href.split('code=')[1].split('&')[0]},
            {
                headers:{
                    "content-type": "application/x-www-form-urlencoded"
                }
            }
        ).then( result =>{
            closeToast();
            if (result.data.success){
                proxy.$cookies.set('OpenId', result.data.openid)
                openid.value = result.data.openid
            }else {
                console.log(result.data.message)
                showDialog({
                    title: '错误提示',
                    message: result.data.message,
                    theme: 'round-button',
                    showConfirmButton:false,
                }).then(() => {
                    // on close
                });
            }
            console.log(result);
        })
    }
    // code.value = location.href.split('code=')[1].split('&')[0];
    //alert(code.value)

})
const placeholderPicker = () => {
    currentDate.value = new Date().toLocaleDateString().split("/")
    showPicker.value = true;
    // console.log(new Date().toLocaleDateString().split("/"))
}
const onConfirm = ({selectedValues}) => {
    results.value = selectedValues.join('/');
    showPicker.value = false;
};
const clickChecked = (e) => {
    checked.value = e;
    if (checked.value == '1'){
        useRefs.value = false;
    }else {
        useRefs.value = true;
    }
    console.log(checked.value)
}
const titleMessage = (val) => {
    if (val.length === 0){
        return "请填写标题"
    }else if (val.length > 10){
        return "填写的标题最大长度为10！"
    }
}
const nameMessage = (val) => {
    if (val.length === 0){
        return "请填写姓名"
    }else if (val.length > 5){
        return "填写的姓名最大长度为5！"
    }
}
const phoneMessage = (val) => {
    console.log(val.substr(0,3))
    if (val.length === 11) {
        const listPhone = ['130', '131', '132', '140', '145', '146', '155', '156', '166', '175', '176', '185', '186', '196', '134', '135', '136', '137', '138', '139', '144', '147', '148', '150', '151', '152', '157', '158', '159', '178', '182', '183', '184', '187', '188', '195', '197', '198', '133', '141', '149', '153', '173', '177', '180', '181', '189', '190', '191', '193', '199', '192'];
        let suc = false;
        for (let i = 0; i < listPhone.length; i++) {
            if (val.substr(0, 3) === listPhone[i]) {
                // eslint-disable-next-line no-unused-vars
                suc = true;
                return;
            }
        }
        if (suc) {
            return;
        } else {
            return "输入的电话号码不合法！";
        }
    }else if (val.length === 0) {
        return "请填写电话号码";
    }else {
        return "输入的电话号码不合法！";
    }
}
const onSubmit = (values) => {
    Object.assign(values,{ type : checked.value,openid : openid.value })
    showLoadingToast({
        overlay:true,
        forbidClick:true,
        message: '提交中...',
        duration:0
        // forbidClick: true,
    });
    /*const timer = setInterval(() => {
        clearInterval(timer);

    },3000)*/

    axios.post("https://afa.activa-leisure.com/lj/back/add_complaint",
        values,
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( result =>{
        closeToast();
        if (result.data.success){
            name.value = ""
            description.value = ""
            result.value = ""
            phone.value = ""
            title.value = ""
            showSuccessToast('提交成功');
        }else {
            showFailToast('提交失败');
        }
    })


};
const bubbleBottom = () => {
    popupShow.value = true
    showLoadingToast({
        overlay:true,
        forbidClick:true,
        message: '加载中...',
        duration:0
    });
    axios.post("https://afa.activa-leisure.com/lj/back/view_complaint",
        {Open_Id:openid.value,state:1},
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( result =>{
        view_complaint.value = result.data.data;
        closeToast();

    })
}
const router = useRouter();
console.log(router)
const cellSubmit = (id) => {
    console.log(id)
   router.push({path: '/DetailsView',query:{id:id}})
}
</script>
<style scoped>
#table-box{
    background-color: white;
}
</style>
